import React, { useState, useMemo } from "react";
import { MessageCircle, X } from "lucide-react";
import UserAvatar from "../atoms/UserAvatar";
import { INK, INK_2, INK_3, LINE, BURGUNDY } from "../../Bureau/bureauTokens";
import { normalizeText } from "../../../utils/text.js";

function NewConversationModal({ users, currentUserId, onClose, onSelect }) {
  const [q, setQ] = useState("");

  const filtered = useMemo(() => {
    const needle = normalizeText(q);
    return (users || [])
      .filter((u) => u.id !== currentUserId)
      .filter((u) => !needle || normalizeText(`${u.name || ""} ${u.lastName || ""}`).includes(needle));
  }, [users, currentUserId, q]);

  return (
    <div className="fixed inset-0 z-[200] flex items-center justify-center bg-black/40" onClick={onClose}>
      <div
        className="w-[420px] mx-4 overflow-hidden flex flex-col"
        style={{ background: "#fff", borderRadius: 16, boxShadow: "0 24px 60px rgba(20,14,24,.30)", maxHeight: "70vh" }}
        onClick={(e) => e.stopPropagation()}
      >
        <div className="flex items-center justify-between px-5 py-4 flex-shrink-0" style={{ background: BURGUNDY, color: "#fff" }}>
          <div className="flex items-center gap-2.5 text-sm font-semibold">
            <MessageCircle size={16} /> Nouveau message
          </div>
          <button onClick={onClose} className="opacity-80 hover:opacity-100">
            <X size={16} />
          </button>
        </div>
        <div className="px-5 py-3.5 flex-shrink-0" style={{ borderBottom: `1px solid ${LINE}` }}>
          <input
            autoFocus
            value={q}
            onChange={(e) => setQ(e.target.value)}
            placeholder="Rechercher un collaborateur…"
            className="w-full h-9 px-3 text-xs outline-none"
            style={{ border: `1px solid ${LINE}`, borderRadius: 8, color: INK_2 }}
          />
        </div>
        <div className="flex-1 overflow-y-auto p-1.5">
          {filtered.map((u) => (
            <button
              key={u.id}
              onClick={() => onSelect(u.id)}
              className="w-full flex items-center gap-2.5 text-left px-3 py-2.5"
              style={{ borderRadius: 10 }}
            >
              <UserAvatar name={u.name} lastName={u.lastName} picture={u.picture} size={32} />
              <span className="text-[12.5px]" style={{ color: INK }}>
                {`${u.name || ""} ${u.lastName || ""}`.trim()}
              </span>
            </button>
          ))}
          {filtered.length === 0 && (
            <div className="px-3 py-6 text-center text-xs" style={{ color: INK_3 }}>
              Aucun collaborateur trouvé
            </div>
          )}
        </div>
      </div>
    </div>
  );
}

export default NewConversationModal;
